/**
 * Global email session capture
 * Listens for email input (any form, including dynamic/Klaviyo) and saves to sessionStorage.
 * The quiz reads from session when showing the email step (no DOM coupling here).
 */
(function () {
  'use strict';

  var SESSION_KEY = 'bbforpets_session_email';
  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isValidEmail(value) {
    return typeof value === 'string' && value.trim().length > 0 && EMAIL_REGEX.test(value.trim());
  }

  function saveEmail(value) {
    var trimmed = value.trim();
    if (!isValidEmail(trimmed)) return;
    try {
      sessionStorage.setItem(SESSION_KEY, trimmed);
    } catch (e) {}
  }

  function handleEmailCapture(event) {
    var target = event.target;
    if (!target || target.type !== 'email') return;
    var value = target.value;
    if (value) saveEmail(value);
  }

  document.addEventListener('blur', handleEmailCapture, true);
  document.addEventListener('change', handleEmailCapture, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.tagName || form.tagName.toLowerCase() !== 'form') return;
    var emailInput = form.querySelector('input[type="email"]');
    if (emailInput && emailInput.value) saveEmail(emailInput.value);
  }, true);
})();
